import { CameraTypeEnum } from '$shared/constants';
import { isDesktop } from '$utils/index';

export function getCameraTypeByLabel(label: string): CameraTypeEnum {
  const selfieCameraKeys = ['передней', 'self', 'front', 'FaceTime', 'web'];

  if (selfieCameraKeys.some((key) => label.toLowerCase().includes(key.toLowerCase()))) {
    return CameraTypeEnum.USER;
  } else {
    return CameraTypeEnum.ENVIRONMENT;
  }
}

export function getMainCamerasFromDevices(devices: MediaDeviceInfo[]): MediaDeviceInfo[] {
  if (isDesktop()) {
    return devices;
  }

  // iOs cameras

  // "Front Camera",
  // "Back Camera",
  // "Back Telephoto Camera",
  // "Back Ultra Wide Camera",
  // "Desk View Camera"

  // "Камера на передней панели",
  // "Камера на задней панели",
  // "Камера с задним телеобъективом",
  // "Задняя сверхширокоугольная камера",
  // "Камера Обзора стола"

  const excludeCameraKeys = [
    // en
    'telephoto',
    'ultra',
    'wide',
    'desk',
    // ru
    'телеобъектив',
    'сверх',
    'широкоугольная',
    'стол',
  ];

  return devices.filter((device) => {
    return (
      device.kind === 'videoinput' &&
      !excludeCameraKeys.some((key) =>
        device.label.toLowerCase().includes(key.toLowerCase()),
      )
    );
  });
}
